var map = {
	"./archive-filled/archive-filled.colored.svg": "ee2d91aabefb31544fbc",
	"./archive/archive.colored.svg": "656a9e5522b26e64d9ad",
	"./arrow-down/arrow-down.colored.svg": "575bc908d304539e7af1",
	"./arrow-stretch/arrow-stretch.colored.svg": "cb093f39c5d9fdb49b21",
	"./arrow-up/arrow-up.colored.svg": "35d8f8cc659fb15c7394",
	"./cart/cart.colored.svg": "06277e2ade18f30f8de5",
	"./delete-green/delete-green.sm.colored.svg": "1766c296c2fd2064191a",
	"./delete-interactive/delete-interactive.colored.svg": "de6e07605cab7c7539ee",
	"./delete-interactive/delete-interactive.sm.colored.svg": "371ebbb9241523e593b0",
	"./delete/delete.colored.svg": "ae05cce7e46d29cb7558",
	"./delete/delete.sm.colored.svg": "9b1ae611d904ed5aff32",
	"./direction-right/direction-right.colored.svg": "a4260bdc7760e9218b4b",
	"./download/download.colored.svg": "23748584f6747516dc9f",
	"./draft/draft.colored.svg": "29c3e1b97db3f28e0c7e",
	"./duplicate-interactive/duplicate-interactive.colored.svg": "c2c47cec7e5a077f1cce",
	"./duplicate/duplicate.colored.svg": "14994ef58af0b7f53d33",
	"./edit-interactive-alt/edit-interactive-alt.colored.svg": "8fc99317719c16215ac9",
	"./edit-interactive/edit-interactive.colored.svg": "4af02fb981ac72ac3c94",
	"./edit/edit.colored.svg": "f285ff9bb66e00b74315",
	"./favorite-blue/favorite-blue.colored.svg": "38766af652e51a2f5040",
	"./favorite-blue/favorite-blue.sm.colored.svg": "b5990e0ea293bd915b1b",
	"./favorite-green/favorite-green.sm.colored.svg": "9784403fd77d1d944fbc",
	"./favorite-white/favorite-white.colored.svg": "be33e2323e28f5d6472a",
	"./favorite-white/favorite-white.sm.colored.svg": "a3faff09ef6faf9c5046",
	"./favorite/favorite.colored.svg": "f74f2a65b5e7535c5a97",
	"./favorite/favorite.sm.colored.svg": "c6cb4c4f679a2e4c22dd",
	"./folder-filled/folder-filled.colored.svg": "b83f83ddd07ad3cf0b29",
	"./folder-with-arrow/folder-with-arrow.colored.svg": "3cd906abf06c620db2f5",
	"./folder/folder.colored.svg": "2d8290815a78753045ab",
	"./gear/gear.colored.svg": "532d35a1093f0e28a7ac",
	"./interactive/interactive.colored.svg": "8c41ca58115ec3baf86a",
	"./ios-share-interactive/ios-share-interactive.colored.svg": "34fe11ed61c00aa17b93",
	"./like/like.colored.svg": "673836868944d3c94b21",
	"./more-vert-interactive/more-vert-interactive.colored.svg": "f92544c8894f9de604c2",
	"./pause/pause.colored.svg": "3bbbdf84ca738abe1e62",
	"./percent/percent.colored.svg": "a5e6836254b0852c985f",
	"./play/play.colored.svg": "69429175da54b3d4ba53",
	"./plus/plus.colored.svg": "48989ef0af8693ba0010",
	"./school-black/school-black.colored.svg": "a47a466d9ee3b4201461",
	"./school-blue/school-blue.colored.svg": "59eead17a2bd27f48300",
	"./school-white/school-white.colored.svg": "66f8adde3a92ca1169a8",
	"./school/school.colored.svg": "6b04b8eec943faeb1940",
	"./send-arrow/send-arrow.colored.svg": "97c6b887d37cc003ddc2",
	"./send-email/send-email.colored.svg": "2f7020d5e7a5d2da4c81",
	"./share-interactive/share-interactive.colored.svg": "7100256bc27cb5e1c472",
	"./star/star.colored.svg": "8ce0578a15330dd11e6f",
	"./tune/tune.colored.svg": "f9510538449853a28c84",
	"./unarchive/unarchive.colored.svg": "bee5ab324154647558df",
	"./visibility-interactive/visibility-interactive.colored.svg": "7037f001ccf8861fe412",
	"./visibility/visibility.colored.svg": "6283ff37b960b1a70548"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f72013ab153263ec7330";